import { render } from "./CorporateHome.vue?vue&type=template&id=21ac2560"
import script from "./CorporateHome.vue?vue&type=script&lang=js"
export * from "./CorporateHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__